module.exports = __webpack_public_path__ + "media/images/header-bg-e16d37d8b43270ca8f5c6bb1c54b4371.jpg";